/**
 * Centralized ability system constants.
 *
 * ALL ability-related magic numbers should live here.
 * No raw numbers in individual ability files.
 */

export const ABILITY_CONSTANTS = {
  // Melee
  MELEE_RANGE_DEFAULT: 65,
  MELEE_ARC_ANGLE: -45,
  MELEE_ARC_SPREAD: 90,
  MELEE_SWING_DURATION: 150,

  // Projectile
  PROJECTILE_LIFESPAN_DEFAULT: 2500,
  PROJECTILE_SPAWN_OFFSET: 40,

  // Homing
  HOMING_STRENGTH_DEFAULT: 10,
  HOMING_MAX_TURN_RATE: 360,
  HOMING_DELAY_DEFAULT: 0,

  // Nova / AoE
  NOVA_LIFESPAN: 800,
  AOE_TICK_INTERVAL_MS: 1000,

  // Bounce / Chain / Split
  BOUNCE_DAMAGE_REDUCTION: 0.15,
  CHAIN_DAMAGE_REDUCTION: 0.2,
  SPLIT_DAMAGE_PERCENT: 0.5,

  // Channel
  CHANNEL_TICK_RATE_MS: 500,

  // Scaling
  LEVEL_SCALING_MELEE: 1.0,
  LEVEL_SCALING_RANGED: 1.5,
  LEVEL_SCALING_AOE: 1.0,
  LEVEL_SCALING_ULTIMATE: 2.0,

  // Fallback balance (used when TOML data is missing)
  FALLBACK_BASE_DAMAGE: 10,
  FALLBACK_SCALE_FACTOR: 0.8,
} as const;
